import t from "./ghl-ui.es840.js";
import o from "./ghl-ui.es841.js";
import a from "./ghl-ui.es842.js";
import r from "./ghl-ui.es843.js";
import m from "./ghl-ui.es844.js";
var e = {
  code: "pt-BR",
  formatDistance: t,
  formatLong: o,
  formatRelative: a,
  localize: r,
  match: m,
  options: {
    weekStartsOn: 0,
    firstWeekContainsDate: 1
  }
};
const p = e;
export {
  p as default
};
